import { useEffect } from 'react';

import { useGetEventsForReview } from '../queries/useGetEventsForReview';

export const useReviewEvents = (
  reviewId: string,
  workspaceId: string,
  prototypeId: string,
) => {
  const {
    refetch: fetchEvents,
    hasNextPage,
    data,
    fetchNextPage,
  } = useGetEventsForReview(workspaceId, prototypeId, reviewId);

  useEffect(() => {
    if (!hasNextPage) return;

    fetchNextPage();
  }, [hasNextPage, data]);

  return {
    fetchEvents,
    data:
      !hasNextPage && data
        ? data.pages.map((page) => page.content || []).flat()
        : [],
  };
};
